import React from 'react'
import PropTypes from 'prop-types'
import { Popup } from 'semantic-ui-react'
import classNames from 'classnames'

import EasyToClickIcon from './EasyToClickIcon'

export const DescriptionPopup = ({
  children,
  className,
  style,
  open,
  onOpen,
  onClose,
  position = 'top center',
}) => (
  <Popup
    basic
    hoverable
    open={open}
    onOpen={onOpen}
    onClose={onClose}
    trigger={
      <EasyToClickIcon className={classNames('icon fas fa-question-circle small', className)} />
    }
    content={children}
    className="wide"
    style={style}
    position={position}
  />
)

DescriptionPopup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  position: PropTypes.string,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/DescriptionPopup.js